export default function AffectationPostePeseeConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('affectation.poste.pesee');
}

AffectationPostePeseeConfiguration.$inject = ['$translatePartialLoaderProvider'];
